// Turns an API legal-page body (plain text) into render blocks. Paragraphs are
// separated by blank lines; a line starting with "## " is a heading. The result
// is only ever rendered as React text nodes, never as HTML.
export function parseLegalBody(body) {
  if (typeof body !== "string") return [];
  const blocks = [];
  let para = [];
  const flush = () => {
    if (para.length) blocks.push({ type: "p", text: para.join("\n") });
    para = [];
  };
  for (const raw of body.replace(/\r\n?/g, "\n").split("\n")) {
    const line = raw.trimEnd();
    if (!line.trim()) {
      flush();
    } else if (line.startsWith("## ")) {
      flush();
      const text = line.slice(3).trim();
      if (text) blocks.push({ type: "h", text });
    } else {
      para.push(line);
    }
  }
  flush();
  return blocks;
}

export const LEGAL_SLUGS = ["impressum", "datenschutz", "agb", "widerruf"];
